// RouteStatusReducer action types
export const LOAD_VIEW = "LOAD_VIEW";
export const UNLOAD_VIEW = "UNLOAD_VIEW";
export const RECEIVE_DATA = "RECEIVE_DATA";
export const UPDATE_ROUTE_DATA_CACHE = "UPDATE_ROUTE_DATA_CACHE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";

// RouteFilterReducer action types
export const SELECT_PRODUCT_TYPE = "SELECT_PRODUCT_TYPE";
export const SELECT_ROUTE_SPEED = "SELECT_ROUTE_SPEED";
export const RECEIVE_FILTER_DATA = "RECEIVE_FILTER_DATA";
export const SELECT_CLUSTER = "SELECT_CLUSTER";
export const SELECT_DRIVER_TYPE = "SELECT_DRIVER_TYPE";
export const SELECT_STATUS = "SELECT_STATUS";
export const SELECT_DEPARTURE = "SELECT_DEPARTURE";
export const SELECT_VIEW_TYPE = "SELECT_VIEW_TYPE";
export const REMOVE_ALL_FILTER = "REMOVE_ALL_FILTER";
export const REMOVE_FILTER = "REMOVE_FILTER";
export const SELECT_STAGE_LOCATION_TYPE = "SELECT_STAGE_LOCATION_TYPE";
export const LOAD_FILTERS = "LOAD_FILTERS";

// CapabilityReducer action types
export const GET_CAPABILITIES = "GET_CAPABILITIES";
export const GET_STATION_CONFIG = "GET_STATION_CONFIG";
export const RECEIVE_STATION_CONFIG = "RECEIVE_STATION_CONFIG";
export const RECEIVE_REFRESH_INTERVAL = "RECEIVE_REFRESH_INTERVAL";

//AssociateReducer action types
export const SET_ASSOCIATE = "SET_ASSOCIATE";
export const RESET_ASSOCIATE_SELECTION = "RESET_ASSOCIATE_SELECTION";



// WEBPACK FOOTER //
// ./src/components/RouteStatus/utils/ReducerActionTypes.js